<template>
  <div class="table-total offset-left-2 offset-right-2">
    <div class="clearfix">
      <!-- Left-->
      <div class="total pull-left fn-sm">
        <div v-if="hasPoint" class="total-item">
          <input class="checkbox" id="bonus" type="checkbox" name="check" v-model="checkPoint" />
          <label class="checkbox-label" for="bonus">
            使用神腦幣折抵
            <b class="value">{{ formatPointMoney }}</b>
          </label>
          <div class="danger spacing left md">
            最高可折抵單筆結帳金額
            <b>{{ pointMaxExchangeRate }}%</b>
          </div>
        </div>
        <div>
          <!-- Hamipoint: 已登入且非R身份且 isFromApp !== 2 者才能顯示-->
          <!--isShowHamiPointBlock, isAuthHamiPoint-->
          <div class="total-item" v-if="isShowHamiPointBlock">
            <div v-if="isAuthHamiPoint">
              <input class="checkbox is-hami-checked" type="checkbox" id="prd-4" :disabled="true" checked />
              <label for="prd-4" class="checkbox-label checkbox-hami">
                您已完成中華會員身分驗證，
                <p class="danger spacing left md fn-sm">
                  <b>下一步【結帳付款頁】可使用 Hami Point 點數折抵金額</b>
                  (您目前可用 Hami Point 點數: {{ hamiPoint | NumberWithPoint }} 點)
                </p>
              </label>
            </div>
            <!-- Hami Point 點數折抵，中華會員身分驗證前-->
            <div v-else>
              <input
                class="checkbox is-hami-checked"
                id="hamipoint"
                type="checkbox"
                name="checkHamipoint"
                v-model="isCheckAuthHamiPoint"
                @change="openModal('HamipointModal')" />
              <label class="checkbox-label" for="hamipoint">
                結帳使用 Hami Point 點數折抵 (1點可折抵1元)
                <p class="fn-sm spacing left md">將前往中華電信驗證會員資料。</p>
                <p class="danger fn-sm spacing left md" v-if="isShowChtLoginMsg">
                  <b>馬上驗證中華會員身份，完成購物即享Hami Point 贈點回饋。</b>
                </p>
              </label>
            </div>
          </div>
          <!-- 宜睿 -->
          <div class="total-item">
            <input
              class="checkbox"
              id="edenred"
              type="checkbox"
              name="checkEdenred"
              :disabled="!isUserNotOwnedEdenredForShowText || unusableEdenredDetailIds.length > 0"
              v-model="isCheckUsedEdenred"
              @change="openModal('EdenredModal')" />
            <label class="checkbox-label" for="edenred">
              結帳時，使用 Edenred 即享券
              <p v-if="isUserNotOwnedEdenredForShowText" class="fn-sm spacing left md">
                將前往驗證 Edenred 即享券序號。
              </p>
              <p v-else class="spacing left md fn-sm">
                已完成驗證，序號
                <span>{{ formatEdenredSerialText }}</span>
                ，
                <span>
                  共{{ getEdenredTotalCount }}筆，合計可用餘額
                  <b class="value">{{ edenredBalanceTotal | dollar }}</b>
                </span>
                <a
                  class="underline spacing left inverted"
                  href="javascript:void(0);"
                  @click="openModal('EdenredModal')">
                  更換序號
                </a>
              </p>
            </label>
            <p class="unusable-edenred-descr" v-if="unusableEdenredDetailIds.length > 0">
              Edenred
              即享券不適用商品-手機、平版電腦、筆記型電腦、遊戲主機、耳機、虛擬票券，購物車內含不適用Edenred即享券的商品，請先移除後，再使用Edenred即享券結帳。
            </p>
          </div>
        </div>
      </div>
      <!-- Right-->
      <div class="total pull-right align right">
        <div class="total-item">
          <span class="label">小計</span>
          <span class="price">{{ subTotal }}</span>
        </div>
        <div v-if="hasPoint" class="total-item">
          <span class="label">神腦幣</span>
          <span class="price">-{{ pointMoney }}</span>
        </div>
      </div>
    </div>
    <auth-hamipoint-alert-modal @cancel="close('hamiPoint')" />
    <edenred-modal @cancel="close('edenred')"></edenred-modal>
  </div>
</template>

<script>
import { commitMutation, renderState, getGetter, commitMutations, getState } from '@/helpers/vuex';
import { NumberWithPoint, dollar } from '@/helpers/format/dollar';
import { openModal } from '@/helpers/modal';
import {
  formatEdenredSerialText,
  edenredBalanceTotal,
  isUserNotOwnedEdenredForShowText,
  getEdenredTotalCount,
} from '@/helpers/edenred';
import { hasPoint } from '@/mixins/cart/main/partial';
import AuthHamipointAlertModal from '@/components/common/modals/hamipoint-modal.vue';
import EdenredModal from '@/components/desktop/main/edenred-modal.vue';

// 是否選用神腦幣的 checkbox 並計算神腦幣折抵金額
const checkPoint = {
  get() {
    return renderState('CartDetail', 'isCheckPoint');
  },
  set(value) {
    commitMutation('CartDetail', 'isCheckPoint', value);
  },
};

const isCheckUsedEdenred = {
  get() {
    return renderState('CartDetail', 'isCheckUsedEdenred');
  },
  set(value) {
    commitMutation('CartDetail', 'isCheckUsedEdenred', value);
  },
};

const props = {
  formatPointMoney: String,
  isAuthHamiPoint: Boolean,
  pointMoney: String,
  subTotal: String,
  hamiPoint: Number,
  pointMaxExchangeRate: Number,
  isShowHamiPointBlock: Boolean,
};

const filters = {
  NumberWithPoint,
  dollar,
};

export default {
  name: 'discount-total',
  filters,
  data() {
    return {
      isCheckAuthHamiPoint: false,
    };
  },
  components: {
    AuthHamipointAlertModal,
    EdenredModal,
  },
  computed: {
    checkPoint,
    getCartDetail: getGetter('CartDetail', 'getterCartDetail'),
    isCheckUsedEdenred,
    isShowChtLoginMsg: getState('CartDetail', 'isShowChtLoginMsg'),
    hasPoint,
    isUserNotOwnedEdenredForShowText,
    formatEdenredSerialText,
    edenredBalanceTotal,
    getEdenredTotalCount,
    // 無法使用宜睿券的明細編號 detailIds
    unusableEdenredDetailIds: getGetter('CartDetail', 'getterUnusableEdenredDetailIds'),
  },
  methods: {
    openModal,
    close(modalName) {
      switch (modalName) {
        case 'hamiPoint':
          this.isCheckAuthHamiPoint = false;
          break;
        case 'edenred':
          commitMutations('CartDetail', {
            isFetchEdenredHasBalance: false,
            edenredIsError: false,
            edenredErrorTxt: '',
            isCheckUsedEdenred: false,
          });
          break;
        // no default
      }
    },
  },
  props,
};
</script>

<style scoped>
.total-item {
  min-height: 40px;
}

.unusable-edenred-descr {
  margin-left: 24px;
}
</style>
